import { render, staticRenderFns } from "./TheService.vue?vue&type=template&id=80cbb9f4&scoped=true&"
import script from "./TheService.vue?vue&type=script&lang=js&"
export * from "./TheService.vue?vue&type=script&lang=js&"
import style0 from "./TheService.vue?vue&type=style&index=0&id=80cbb9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cbb9f4",
  null
  
)

export default component.exports